import {Component, Inject, LOCALE_ID} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-settings-support-article',
    template: `
        <ng-container i18n="@@support.articles.settings">
            <p>Tyyp is available in different languages and keyboard layouts. By default, you will be shown the course that best suits your region and language.</p>
            <figure>
                <img src="assets/images/support/languagePicker.png"/>
                <figcaption>Open the language menu at the top of the page and choose the desired region and language.</figcaption>
            </figure>
            <h2>Change keyboard layout</h2>
            <ol>
                <li>
                    <span>Go to <a routerLink="/account/preferences">My account - Preferences</a>.</span>
                </li>
                <li>
                    <span>
                        Click the pencil icon next to your current keyboard layout.
                        <br/>
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/keyboardLayout.png"/>
                    </span>
                </li>
                <li>
                    <span>Now choose the desired keyboard layout from the list.</span>
                </li>
            </ol>

            <h2>Apple keyboards</h2>
            <p>Apple keyboards have a slightly different layout. The course is adjusted for this, so you can learn to type with an Apple keyboard as well! You only need to enable this option in your account.</p>
            <ol>
                <li>
                    <span>Go to <a routerLink="/account/preferences">My account - Preferences</a>.</span>
                </li>
                <li>
                    <span>
                        Check the "I use an Apple keyboard" option.
                        <br/>
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/appleKeyboard.png"/>
                    </span>
                </li>
            </ol>

            <h2>Sound settings</h2>
            <p>Sound effects and music are used in the course and in the typing games. You can turn this off in your account settings.</p>
            <ol>
                <li>
                    <span>Go to <a routerLink="/account/preferences">My account - Preferences</a>.</span>
                </li>
                <li>
                    <span>
                        Enable the desired settings.
                        <br/>
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/audioSettings.png"/>
                    </span>
                </li>
            </ol>
        </ng-container>
    `
})
export class SettingsSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
